
import { Component, Vue, Prop } from "vue-property-decorator";
import moment from "moment";

@Component
export default class ViewCourseDetails extends Vue {
  @Prop({ default: [] })
  course: any;
      formatTrainingDate(value){
    let val = moment(String(value)).format('DD-MM-YYYY');
     if(val == "Invalid date"){
       return "";
     }
     else{
       return val;
     }
  }
}
